// Claude: Buyer asset Redux slice — mirrors sellerAssetSlice 25-02-2026
import { createSlice } from "@reduxjs/toolkit";

const buyerAssetSlice = createSlice({
  name: "buyerAsset",
  initialState: {
    links: [],
    link: "",
    title: "",
  },
  reducers: {
    setAssets: (state, action) => {
      state.links = action.payload.links;
    },
    setLink: (state, action) => {
      state.link = action.payload.link;
    },
    setTitle: (state, action) => {
      state.title = action.payload.title;
    },
    resetForm: (state, action) => {
      state.link = "";
      state.title = "";
    },
  },
});

export const { setAssets, setLink, setTitle, resetForm } = buyerAssetSlice.actions;
export const buyerAssetReducer = buyerAssetSlice.reducer;
